import $ from "jquery";

const getSelectValue = (parameters, term) => {
    const selectElement = $(".js-filter-offices");
    parameters[term] = selectElement.val();
    const selectedText = selectElement.find("option:selected").text();

    return { parameters, selectedText };
};

const filterAjax = (el) => {
    let selectedText = "";

    $(".js-filter-offices").on("change", function () {
        const parameters = {};
        const type = el.getAttribute("data-query-type");

        const updatedValues = getSelectValue(parameters, type);
        selectedText = updatedValues.selectedText;

        const queryString = $.param(updatedValues.parameters);
        const url = queryString ? `?${queryString}` : window.location.pathname;
        window.history.pushState(null, "", url);


        $(el).submit();
    });

    $(el).on("submit", function (e) {
        e.preventDefault();

        const type = el.getAttribute("data-query-type");
        $.ajax({
            type: "POST",
            url: "/wp/wp-admin/admin-ajax.php",
            dataType: "html",
            data: {
                action: "filter_" + type,
                types: $(this).serializeArray(),
                ajaxUrl: window.location.href,
                postType: $(el).data("post-type"),
            },
            success: function (res) {
                $(".js-search-list").html(res);
                $(".archive__search-result-text--bold").text(selectedText);
                $(".archive__search-result").show();
            },
            error: function (err) {
                console.error(err);
            },
        });
    });
};

export default filterAjax;
